import type { ApiSearchableSelectOption } from '../components/ApiSearchableSelect'

type AssetTypeLike = {
    code?: string
    name?: string | Record<string, string | undefined> | null
}

// assetTypeFilterOptions turns the organization's asset types into the
// options of the assets page's type filter, labelled in locale. The page
// derives them from the useAssetTypes query, so a failed load retries and
// shows its error instead of leaving the filter silently empty (#1720).
export function assetTypeFilterOptions(types: readonly AssetTypeLike[], locale: string): ApiSearchableSelectOption[] {
    return types.map(type => ({
        value: type.code ?? '',
        label: typeof type.name === 'string'
            ? type.name
            : type.name?.[locale] || type.name?.['en'] || type.name?.['fr'] || type.code || 'Unknown',
    }))
}
